module.exports = __webpack_public_path__ + "static/media/tango-press-button.00a750d2.svg";